// The loading skeleton. `Skeleton` is the component, for any component to
// wrap its content in while it loads; plugins without the import use the
// `shared.skeleton` extension (plugin shared-skeleton) with the same props.
// See docs/architecture/core/plugin-shared-skeleton.md.
export { Skeleton, type SkeletonProps, type SkeletonVariant, type SkeletonAnimation } from './Skeleton.tsx';
export { skeletonSource, skeletonStyle, unionSize, SKELETON_DELAY_MS, DEFAULT_HEIGHT, type MeasuredSize, type SkeletonSize, type SkeletonSource } from './skeleton-box.ts';

/** The extension that renders a skeleton, for a plugin that prefers a slot: params are `SkeletonProps`. */
export const SKELETON_EXTENSION = 'shared.skeleton';
